import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  clearPwaRestoreMarkers,
  getPwaPathToRestoreAfterReload,
  savePwaLastRoute,
} from '@/lib/pwaRoutePersistence';

const ROOT_PATHS = new Set(['/', '', '/index.html']);

/**
 * Guarda la ruta en cada cambio y, si el refresh dejó `/`, navega a la pantalla anterior.
 */
export function PwaRouteSync() {
  const location = useLocation();
  const navigate = useNavigate();
  const restoredRef = useRef(false);

  useEffect(() => {
    if (restoredRef.current) return;
    const target = getPwaPathToRestoreAfterReload();
    if (!target) return;
    const atRoot = ROOT_PATHS.has(location.pathname) && !location.search;
    if (!atRoot) return;
    restoredRef.current = true;
    clearPwaRestoreMarkers();
    navigate(target, { replace: true });
  }, [location.pathname, location.search, navigate]);

  useEffect(() => {
    savePwaLastRoute(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}
